<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="CO">It’s an impossible choice. How am I supposed to make it?</p>
<p class="TX">I think back over the past few weeks and everything that has happened to bring me to this point.</p>
<p class="TX">It doesn’t matter. <span class="ePub-I">None</span> of it matters now.</p>
<p class="TX">All that counts is this choice.</p>
<p class="TX">This impossible choice.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preclude.vue?036ebcb8